'use client'
import { Navigate } from 'react-router-dom'
import { useSearchParams, getTranslations } from '@/lib/next-shim'
import { PageTitle } from '@/shared/ui/seo/PageTitle'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { getOrderCategory } from '@/entities/order'

import { OrdersList } from './OrdersList'
import type { OrdersFilterTabValue } from './OrdersFilterTabs'

const VALID_TABS: OrdersFilterTabValue[] = ['active', 'completed', 'cancelled']

export function OrdersPage() {
  const searchParams = useSearchParams()
  const tab = searchParams?.get('tab') as OrdersFilterTabValue | null
  const t = getTranslations()

  const { data, loading, error } = useGetMyInfosQuery()
  const myInfos = data?.myInfos

  if (!tab || !VALID_TABS.includes(tab)) {
    return <Navigate to="?tab=active" replace />
  }

  if (loading) return <div className="p-10 text-center">{t('common.loading')}</div>
  if (error) return <div className="p-10 text-center text-red-500">{t('common.error', { message: error.message })}</div>

  const orders = (myInfos?.orders ?? [])
    .filter((order) => getOrderCategory(order.status) === tab)
    .slice()
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())

  return (
    <div className="flex-1 overflow-auto p-2 sm:p-4 md:p-6">
      <PageTitle title={t('account.sections.Orders.title')} />
      <h1 className="sr-only">{t('account.sections.Orders.title')}</h1>
      <OrdersList orders={orders} tab={tab} />
    </div>
  )
}
